import { useProducts } from '../../features/catalog/queries.js';
import { Section, SectionHeading } from '../layout/Section.jsx';
import { ProductRail } from './ProductRail.jsx';

/**
 * One home page row for one category — Attars, Perfumes, Oud.
 *
 * The home page draws one for every top-level category that has products, in
 * the order the admin panel sets, so a category an operator adds or renames
 * shows here with no deploy. A category with nothing published steps aside,
 * and stays out while its query is in flight so an empty one never flashes a
 * row of skeletons and then collapses.
 */
export const CategoryShelf = ({ category, onQuickAdd, autoplay = false, direction = 1, className }) => {
  const products = useProducts({ category: category.slug, sort: 'newest', limit: 12 });

  if (!products.data?.length) return null;

  return (
    <Section className={className}>
      <SectionHeading
        eyebrow="Shop by type"
        title={category.name}
        description={category.description || undefined}
        action={{ label: `See all ${category.name.toLowerCase()}`, to: `/category/${category.slug}` }}
      />
      <ProductRail
        products={products.data}
        isPending={false}
        onQuickAdd={onQuickAdd}
        label={category.name}
        autoplay={autoplay}
        direction={direction}
      />
    </Section>
  );
};

export default CategoryShelf;
